import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconInjection: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="injection"><path d="M17.5 2.5L21.5 6.5" stroke="currentColor" strokeWidth="1.5"/><path d="M19.5 4.5L17 7" stroke="currentColor" strokeWidth="1.5"/><path d="M12.5 3.5L20.5 11.5" stroke="currentColor" strokeWidth="1.5"/><path d="M14.5962 5.25L5.25 14.5962L9.40385 18.75L18.75 9.40385" stroke="currentColor" strokeWidth="1.5"/><path d="M3 21L7.5 16.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconInjection;
